// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === "vendors") return "js/" + chunkId + ".b7f0ae148ac03ee2472a.js";
	// return url for filenames based on template
	return undefined;
};